import { BundleComponent, BundleStockMode, ProductEntity } from '@models';

export interface BundleVariantOption {
  id: number;
  sku: string;
  itemCode?: string;
  stock?: number;
  isManageableStock?: boolean;
  regularPrice: number;
  salePrice?: number | null;
}

export interface BundleComponentSelection extends BundleComponent {
  productId: number;
  productName: string;
  imageUrl?: string;
  variants: BundleVariantOption[];
  stockLoaded: boolean;
}

export function createBundleComponentSelection(
  productId: number,
  product: ProductEntity,
  selectedVariantIds: ReadonlySet<number>,
): BundleComponentSelection | null {
  const variant = product.variants.find((candidate) => !selectedVariantIds.has(candidate.id));
  if (!variant) return null;

  return {
    productId,
    productName: product.name.english || product.name.arabic || 'Unnamed Product',
    imageUrl: product.images?.[0]?.url,
    componentVariantId: variant.id,
    quantity: 1,
    unitPrice: effectiveBundleComponentPrice(variant),
    variants: product.variants,
    stockLoaded: true,
  };
}

export function effectiveBundleComponentPrice(variant: BundleVariantOption): number {
  return variant.salePrice ?? variant.regularPrice;
}

export function isBundleStockModeOptionSelected(
  currentMode: BundleStockMode,
  optionMode: BundleStockMode,
): boolean {
  return currentMode === optionMode;
}
